import { Component, ElementRef, OnInit, Renderer2, HostListener } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'portals-faq',
  templateUrl: './faq.component.html',
  styleUrls: ['./faq.component.scss'],
})
export class FAQComponent implements OnInit {
  faq = [
    {
      question: "What is Jotto?",
      answer: [
        "Jotto enables people to share feedback instantly."
      ]
    },
    {
      question: "How do organizations access the Jotto portal?",
      answer: [
        'Each organization has its own secure login accessed via <a style="color: #fbd364;" href="https://console.jotto.me" target="_blank">https://console.jotto.ai</a>.'
      ]
    },
    {
      question: "Do people need to install an app to use Jotto?",
      answer: [
        "Nope! Jotto works in web browsers so anyone can instantly share stories wherever they have access to the internet and a compatible browser. That being said, the Jotto mobile app has cool features that would be impossible in a web browser, like the ability to record videos online or off and access to news feeds."
      ]
    },
    {
      question: "Who owns the recordings?",
      answer: [
        "Both the person who made the recording and the organization that it was sent to own the rights to the recordings."
      ]
    },
    {
      question: "Do I have to download an app on my phone?",
      answer: [
        "Not at all! You can instantly share your feedback via our web app on desktop and mobile devices. Here’s the thing, the Jotto app has some cool features the web app doesn’t, like the ability to record without an internet connection, a news feed and interactive Jotts. So we think you should… but totally not necessary."
      ]
    },
    {
      question: "What personal information, if any, is being collected?",
      answer: [
        "We respect people’s privacy! We are not interested in your personal information. There is no registration so no exchange of phone numbers, email addresses, physical addresses, birthdates, names, no PINS, no passwords, no nothing! That being said, when you record feedback, it's up to you how much personal information you wish to share; for instance what you say when you record a story or if you opt in to share your location. The information you record is shared with the organization who’s Jott you are responding to, so please bear this in mind."
      ]
    },
    {
      question: "Who has access to this information?",
      answer: [
        "The organization who’s channel you have subscribed to (the channel owner) does have access to the feedback you share. They can use this information and content as they see fit. The Jotto team in rare cases may have access to the feedback and data, for instance if we need to help an organization with a technical difficulty. We keep these interactions as brief as possible and we will keep anything we come across private."
      ]
    },
    {
      question: "How is this information being protected?",
      answer: [
        "We have a secure cloud server where the data is encrypted at rest. This means that only the people who have access to this information can access this information."
      ]
    },
    {
      question: "Will I be marketed to by Jotto?",
      answer: [
        "We hate spam too! The Jotto app includes a subscription to the Jotto channel. We use this mainly to keep you up to date with news and feature updates. If that encourages you to sign up your organization to start using Jotto, amazing!"
      ]
    }
  ];

  faqSelected: number | null = null;

  constructor(
    private renderer: Renderer2,
    private elRef: ElementRef,
    private sanitizer: DomSanitizer
  ) {}

  ngOnInit(): void {}

  toggleFaq(index: number): void {
    this.faqSelected = this.faqSelected === index ? null : index;
  }

  getMaxHeight(index: number): number {
    const element = this.elRef.nativeElement.querySelectorAll('.item')[index].querySelector('.relative');
    return element.scrollHeight;
  }

  sanitizeHtml(html: string): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(html);
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: Event) {
    if (this.faqSelected !== null) {
      const index = this.faqSelected;
      const element = document.querySelectorAll('.faq-content')[index] as HTMLElement;
      if (element) {
        (element as HTMLElement).style.maxHeight = element.scrollHeight + 'px';
      }
    }
  }
}
